// Device fingerprinting utility
// Generates a unique identifier for the device/browser

export const getDeviceFingerprint = () => {
  // Check localStorage first for existing device ID
  let deviceId = localStorage.getItem('deviceId');
  
  if (!deviceId) {
    // Generate device fingerprint from browser characteristics
    const components = [
      navigator.userAgent,
      navigator.language,
      window.screen.width + 'x' + window.screen.height + 'x' + window.screen.colorDepth,
      new Date().getTimezoneOffset(),
      navigator.hardwareConcurrency || 'unknown',
      navigator.platform,
      navigator.maxTouchPoints || 0
    ];
    
    // Create a hash-like string from components
    const fingerprint = btoa(components.join('|'))
      .replace(/[^a-zA-Z0-9]/g, '')
      .substring(0, 32);
    
    // Create unique device ID with timestamp
    deviceId = `device_${fingerprint}_${Date.now()}`;
    
    // Store in localStorage for persistence
    localStorage.setItem('deviceId', deviceId);
  }
  
  return deviceId;
};

// Clear device ID (useful for testing or explicit logout)
export const clearDeviceFingerprint = () => {
  localStorage.removeItem('deviceId');
};
